import { FooterAdditionalItem, Link } from 'src/__generated__/graphqlTypes';
import { FooterTypeInterface } from 'components/Footer/declarations';

export interface FooterCopyrightContainerInterface extends FooterTypeInterface {
  copyrightDescription: string;
  copyrightLinks: Array<Link>;
  desktopSiteRequest: string;
  mobileSiteRequest: string;
  additional?: Array<FooterAdditionalItem>;
}

export interface FooterCopyrightInterface
  extends FooterCopyrightContainerInterface {
  isMobileView: boolean;
  isDesktopRequested: boolean;
  requestAnotherSiteView: () => void;
  policyUpdateDate?: Record<string, any>;
}

export enum CopyrightSlug {
  PRIVACY_POLICY = 'privacy-policy',
  TERMS_OF_USE = 'terms-of-use',
  SITE_MAP = 'site-map',
  PERSONAL_INFO = 'personal-info',
}

export interface CopyrightLinksInterface {
  copyrightLinks: Array<Link>;
  policyUpdateDate?: Record<string, any>;
}

export interface CopyrightLinkInterface {
  link: Link;
  policyUpdateDate?: Record<string, any>;
}
